import { projectClient } from '../../client/client';

export const charge = {
  issue: projectClient('/payment/charge/issue').post,
  status: projectClient('/payment/charge/status').post,
};
